import { Container, Spinner } from "react-bootstrap";
import MediaQueryTool from "../../utils/MediaQueryTool";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import { Navigation, Pagination, EffectCoverflow } from "swiper/modules";
import { useEffect, useState } from "react";
import axios from "axios";

const Showcase = () => {
  const mediaQueryTool = MediaQueryTool();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    axios
      .get("https://sugarno_backend.sugarnoproject.workers.dev/getHighlight")
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => console.error(error))
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <>
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Optional overlay
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      {data && (
        <div
          className={`${
            !mediaQueryTool.isXS ? "defaultContainer" : undefined
          } mb-4 d-flex flex-column`}
          style={{
            height: `${mediaQueryTool.isXS ? "60vh" : "120vh"}`,
          }}
        >
          <Container
            className="d-flex flex-column align-items-center"
            style={{
              marginTop: !mediaQueryTool.isXS ? 80 : 65,
              color: "white",
            }}
          >
            <h1
              className="neon-text2"
              style={{
                fontFamily: "CyberpunkFont",
              }}
            >
              Highlight
            </h1>
          </Container>
          <Container
            style={{
              marginTop: 20,
              height: "100%",
              width: "100%",
            }}
          >
            <Swiper
              navigation
              pagination={{ clickable: true }}
              effect="coverflow"
              modules={[Navigation, Pagination, EffectCoverflow]}
              className="mySwiper"
              loop
              grabCursor
              centeredSlides
              slidesPerView={2}
              coverflowEffect={{
                rotate: 0,
                stretch: 20,
                depth: 200,
                modifier: 1,
                slideShadows: false,
              }}
              color="white"
              style={{ height: "100%", width: "100%", position: "relative" }}
            >
              {data.map((item, index) => (
                <SwiperSlide
                  style={{
                    backgroundImage: `url(${item.url})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                  key={index}
                />
              ))}
            </Swiper>
          </Container>
        </div>
      )}
    </>
  );
};

export default Showcase;
